import React, { useRef, useState } from 'react';
import { Input, Tooltip } from 'antd';

const OverflowInput = (props) => {
  const inputRef = useRef(null);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  // 检测内容是否溢出
  const checkOverflow = () => {
    const inputEl = inputRef.current?.input;
    if (!inputEl) return false;
    return inputEl.scrollWidth > inputEl.clientWidth;
  };

  // 处理悬停和聚焦事件
  const handleShowTooltip = () => {
    if (checkOverflow()) {
      setIsTooltipVisible(true);
    }
  };

  // 隐藏 Tooltip
  const handleHideTooltip = () => {
    setIsTooltipVisible(false);
  };

  return (
    <Tooltip
      title={inputRef.current?.input?.value} // Tooltip 显示内容
      open={isTooltipVisible}
      overlayStyle={{ maxWidth: 'none' }} // 防止自动换行
    >
      <Input
        ref={inputRef}
        disabled={props.disabled}
        value={props.value}
        onChange={props.onChange}
        onMouseEnter={handleShowTooltip}
        onMouseLeave={handleHideTooltip}
        onFocus={handleShowTooltip}
        onBlur={handleHideTooltip}
        style={{
        //   width: 200, // 自定义宽度
          height: '33.98px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          fontFamily: 'Inter',
          fontSize: '16px',
          color: '#222',
          lineHeight: 'normal',
        }}
      />
    </Tooltip>
  );
};

export default OverflowInput;